module.exports = __webpack_public_path__ + "media/images/chat-9e43ba049bd736c4c59ea2d7da12f5ed.svg";